<div class="admin-tools seccion-media">
  <p>admin tools</p>
  <form [formGroup]="toolsForm" class="contact-form">
    <ul>
      <li>
        <div class="encrypt-pass">
          <div>
            <input formControlName="password" type="text" name="password">
            <button (click)="encrypt()">encriptar</button>
          </div>
          <div>
            <span>{{ message }}</span>
          </div>
        </div>
      </li>
      <li>
        <input formControlName="preferenceId" type="text" name="preference-id">
        <button (click)="chechearPreference()">checkear preference</button>
      </li>
      <li>
        <input formControlName="paymentId" type="text" name="payment-id">
        <button (click)="checkearPayment()">checkear payment</button>
      </li>
    </ul>
  </form>
  <div class="text-area">
    <textarea name="response">{{ response }}</textarea>
    <button (click)="clear()">clear</button>
  </div>
</div>